import React from "react";
import Head from "next/head";
import Script from "next/script";
import { BodySection } from "container/africa-fest/body-section";
import { OrganizerInfoFooter } from "container/africa-fest/footer";
import { HeroSection } from "container/africa-fest/hero-section";
import { PageContainer } from "container/africa-fest/page-container";
import { AppContainer } from "container/app-container";

const AfricaEducationFest = () => {
   return (
      <div>
         <Head>
            <script>
               {`!function(f,b,e,v,n,t,s)
                  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                  n.queue=[];t=b.createElement(e);t.async=!0;
                  t.src=v;s=b.getElementsByTagName(e)[0];
                  s.parentNode.insertBefore(t,s)}(window, document,'script',
                  'https://connect.facebook.net/en_US/fbevents.js');
                  fbq('init', '1073569473597848');
                  fbq('track', 'PageView');
               `}
            </script>
            <noscript>
               {` <img
                     alt="no-script"
                     height="1"
                     width="1"
                     style="display:none"
                     src="https://www.facebook.com/tr?id=1073569473597848&ev=PageView&noscript=1"
                  />`}
            </noscript>
            <Script
               id="adsbygoogle-init"
               strategy="lazyOnload"
               crossOrigin="anonymous"
               src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7449886307312276"
            />
         </Head>

         <AppContainer
            title="Africa Education Festival in London UK"
            description="The Africa Education Fest was created in 2019 by Edusko as an avenue for African parents in the diaspora to meet with top schools in Nigeria, Ghana, Kenya, Uganda and more."
            image="/images/africafest.png"
            slug={typeof window !== "undefined" ? window.location.href : ""}
         >
            <PageContainer>
               <HeroSection />
               <BodySection />
               <OrganizerInfoFooter />
            </PageContainer>
         </AppContainer>
         <Script
            id="adsbygoogle-init"
            strategy="lazyOnload"
            crossOrigin="anonymous"
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7449886307312276"
         />
      </div>
   );
};

export default AfricaEducationFest;
